export const searchableValue = {
  generate: ({ id, title, link }) => `${id}-${title}-${link}`,
  destructure: (value) => { 
      const [id, title, link] = value.split('-');
      return {id, title, link}
    },
};
